export default __webpack_public_path__ + "static/media/notificationsLight.6d7f79b4.svg";